/* eslint-disable prettier/prettier */
/*
public function showSelectedProducts()
    {
        // Subhead
        $subhead = "Versicherte Gegenstände";
        $this->textflow = $this->pdf->add_textflow($this->textflow, "\n$subhead", $this->smallBoldOptions . " fillcolor=" . $this->colors->rgb->headline);
        $this->dumpThisTextflow(75);
        // Go
        // Schleife für alle Produkte
        foreach ($this->viergewinnt->offerRequest->contract->products as $key => $product) {
            $this->showProductByIndex($product, $key);
        }
    }

public function showProductByIndex($product, $key)
    {
        // 1. Text ausgeben
        // Subhead
        $subhead = ($key + 1) . ". versicherter Gegenstand";
        $this->textflow = $this->pdf->add_textflow($this->textflow, "$subhead", $this->smallBoldOptions . " fillcolor=" . $this->colors->rgb->copy);
        $this->textflow = $this->pdf->add_textflow($this->textflow, "\n", $this->distanceOptions);
        $copy = "\nKategorie:\t" . $product->label . "\nHersteller/Modell:\t" . $product->producer;
        if ($product->imei != "") {
            $copy .= "\nIMEI:\t" . $product->imei;
        }
        $this->textflow = $this->pdf->add_textflow($this->textflow, $copy . "\n", $this->regularOptions);
        $this->dumpThisTextflow(60);
        // 2. Bilder ausgeben
        $imgSpaceHeight = 0;
        foreach ($product->pictures as $picKey => $pic) {
            $imgSpaceHeight = max($imgSpaceHeight, $this->showProductImageByIndex($pic, $key, $picKey));
        }
        $this->pagePosition->y -= ($imgSpaceHeight);
    }

    public function showProductImageByIndex($pic, $prodKey, $picKey)
    {
        $cellHeight = 70;
        $xMargin = 10;
        // 1. Bilddateien erzeugen
        $img = $pic->data;
        $img = str_replace('data:image/png;base64,', '', $img);
        $img = str_replace('data:image/jpg;base64,', '', $img);
        $img = str_replace('data:image/jpeg;base64,', '', $img);
        $img = str_replace(' ', '+', $img);
        $imagedata = base64_decode($img);
        $this->pdf->create_pvf("/pvf/image/" . $prodKey . "_" . $picKey, $imagedata, "");

        // Load the image from the PVF
        $image = $this->pdf->load_image("auto", "/pvf/image/" . $prodKey . "_" . $picKey, "");
        if ($image != 0) {
            // Bild ausgeben
            $h = $this->pdf->info_image($image, "imageheight", "");
            $w = $this->pdf->info_image($image, "imagewidth", "");
            $prop = $w / $h;
            $cellWidth = $cellHeight * $prop;
            $xOffset = $picKey * $cellWidth + ($picKey * $xMargin);
            // Verfügbaren Platz nach unten prüfen
            if ($this->pagePosition->y - $cellHeight < $this->mm2p(35)) {
                $this->nextPage();
            }
            $this->pdf->fit_image($image, $this->pagePosition->x + $xOffset, $this->pagePosition->y - $cellHeight, 'boxsize={' . $cellWidth . ' ' . $cellHeight . '} position={center} fitmethod=meet orientate=north');
            return ($cellHeight + $xMargin);
        }
        return 0;
    }    
*/
const selectedProducts = [
    [
        {
            text: "Versicherte Gegenstände\n\n", style: "subHeadOptions",
            margin: [0, 20, 0, 0]
        },
        {
            table: { widths: [150, 100], body: '__selectedProducts__' },
            layout: "noBorders",
            style: "regularOptions"
        }
    ]
]

export { selectedProducts }